import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import StudentAccessFrequencyGauge from './StudentAccessFrequencyGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { StudentAccessFrequencyListService } from '../../services/CustomerSuccessKpiListService';

class StudentAccessFrequencyGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    StudentAccessFrequencyListService.load();
  }

  render() {
    return (
      <StudentAccessFrequencyGauge
        loading={
          StudentAccessFrequencyListService.fetchCurrent.fetching ||
          StudentAccessFrequencyListService.fetchPrevious.fetching
        }
        currentValue={toJS(StudentAccessFrequencyListService.global.current)}
        previousValue={toJS(StudentAccessFrequencyListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('STUDENT_ACCESS_FREQUENCY')}
        formatter={StudentAccessFrequencyListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentAccessFrequencyGaugeContainer);
